import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

import Chart from "Components/Common/Chart";
import { statusChartColors } from "common/constant";

const InspectionStatusPieChart = ({ changeCategoryType, data, labels, t }) => {
  const options = {
    chart: {
      type: "pie",
      events: {
        click: (_, __, config) => {
          const id = config?.globals?.selectedDataPoints?.[0]?.[0];
          handleChangeCategoryType(id, config);
        },
        legendClick: (_, id, config) => {
          changeCategoryType((prev) => ({
            title: options?.labels?.[id] ?? prev.title,
            color: config?.globals?.colors?.[id] ?? prev.color,
          }));
        },
      },
    },
    // plotOptions: {
    //   pie: {
    //     donut: {
    //       labels: {
    //         show: true,
    //         total: {
    //           showAlways: true,
    //           show: true,
    //         },
    //       },
    //     },
    //   },
    // },
    fill: {
      type: "gradient",
    },
    labels,
    legend: {
      position: "bottom",
      horizontalAlign: "left",
      onItemClick: {
        toggleDataSeries: true,
      },
      onItemHover: {
        highlightDataSeries: false,
      },
      formatter: (seriesName, opts) => [
        seriesName,
        " - ",
        opts.w.globals.series[opts.seriesIndex],
      ],
    },
    colors: statusChartColors,
  };

  const handleChangeCategoryType = (id, config) => {
    changeCategoryType((prev) => ({
      title: config?.config?.labels?.[id] ?? prev.title,
      color: config?.globals?.colors?.[id] ?? prev.color,
    }));
  };

  return (
    <Chart
      options={options}
      series={data}
      title={t("Inspection Status")}
      type="pie"
      height={350}
    />
  );
};

InspectionStatusPieChart.propTypes = {
  changeCategoryType: PropTypes.func,
  data: PropTypes.array,
  labels: PropTypes.array,
  t: PropTypes.func,
};

export default withTranslation()(InspectionStatusPieChart);
